import React, { useMemo, forwardRef } from 'react';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';

const animatedComponents = makeAnimated();

const Select2Component = forwardRef(({ value, options, onChange, ...props }, ref) => {

    const safeOptions = useMemo(() => options || [], [options]);

    // Built by walking `value`, never by filtering `options` — filtering would
    // re-order the chips into the option list's order (i.e. alphabetically) and
    // throw away the order the user picked them in, which is what gets submitted.
    const selected = useMemo(() => {
        const list = Array.isArray(value) ? value : (value == null || value === '' ? [] : [value]);
        const byValue = new Map(safeOptions.map(o => [o.value, o]));
        return list.map(v => byValue.get(v)).filter(Boolean);
    }, [value, safeOptions]);

    const handleChange = (selectedValue) => {
        // react-select appends each new pick to the end, so this is pick order.
        onChange((selectedValue ? [].concat(selectedValue) : []).map(x => x.value));
    }

    return (
        <Select
            ref={ref}
            components={animatedComponents}
            value={selected}
            options={safeOptions}
            onChange={handleChange}
            {...props}
            classNamePrefix="select"
        />
    )
});

Select2Component.displayName = 'Select2Component';

export default Select2Component;
